import { THeadingTag } from '../../../types/types';
import { THeroCarouselParams, HeroCarouselProps, THeroCarouselFields, THeroCarouselItemFields } from '../types/herocarousel.types';

export class HeroCarouselModel {
  private readonly fields?: THeroCarouselFields;
  private readonly rendering?;
  private readonly params?: THeroCarouselParams;

  constructor(props: HeroCarouselProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
    this.params = props?.params;
  }

  get carouselSlide(): THeroCarouselItemFields[] {
    return (
      this.fields?.items?.map(({ fields }) => {
        return {
          image: fields?.image,
          mobileImage: fields?.mobileImage,
          title: fields?.title,
          content: fields?.content,
          link: fields?.link,
          textColor: fields?.textColor?.fields?.Key,
          video: fields?.video,
          useVideo: fields?.useVideo,
          downloadButtonLink: fields?.downloadButtonLink,
        };
      }) || []
    );
  }

  get dataSource(): boolean {
    return !!this.rendering?.dataSource;
  }

  get showCauroselOverlay(): boolean {
    return !!this.fields?.showCarouselOverlay?.value;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }
}
